// Arabic translations (RTL)
export const ar = {
  brand: { name: "هاندي مايستر", tagline: "إصلاح الهواتف الذكية" },
  nav: {
    home: "الرئيسية", repair: "الإصلاح", prices: "الأسعار",
    appointment: "حجز موعد", status: "حالة الإصلاح",
    shipping: "إصلاح عبر البريد", locations: "الفروع",
    about: "من نحن", faq: "الأسئلة الشائعة", contact: "اتصل بنا", admin: "الإدارة",
  },
  cta: {
    startRepair: "ابدأ الإصلاح", bookAppointment: "احجز موعداً",
    viewPrices: "عرض الأسعار", whatsapp: "استفسر عبر واتساب",
    selectDevice: "اختر الجهاز", showModels: "عرض الطرازات",
    showRepairs: "عرض الإصلاحات", select: "اختر", next: "التالي",
    back: "رجوع", submit: "إرسال", save: "حفظ", startOver: "ابدأ من جديد",
    sendRequest: "إرسال طلب الإصلاح", startShipping: "بدء الإصلاح عبر البريد",
    savePdf: "حفظ كملف PDF",
  },
  hero: {
    title: "إصلاح احترافي للهواتف الذكية.",
    subtitle: "سريع وشفاف وموثوق.",
    description:
      "اختر هاتفك الذكي وخدمة الإصلاح المطلوبة. ستشاهد السعر التقديري فوراً ويمكنك حجز موعد أو إرسال طلب مباشرة.",
  },
  trust: {
    prices: "أسعار شفافة", fast: "إصلاح سريع",
    quality: "قطع غيار عالية الجودة", warranty: "ضمان الإصلاح",
    data: "معالجة آمنة للبيانات",
  },
  configurator: {
    step1: "الماركة", step2: "الطراز", step3: "الإصلاح",
    step4: "الجودة", step5: "الملخص", step6: "الحجز أو الطلب",
    selectBrand: "اختر الماركة", selectModel: "اختر الطراز",
    selectRepair: "اختر الإصلاح", selectQuality: "اختر الجودة",
    summary: "ملخص الإصلاح",
    searchBrand: "ابحث عن ماركة", searchModel: "ابحث عن طراز",
    modelNotListed: "طرازي غير موجود في القائمة",
    supportedModels: "طرازات مدعومة", startingFrom: "ابتداءً من",
    duration: "المدة", warranty: "الضمان", warrantyMonths: "أشهر ضمان",
    minutes: "دقيقة", total: "السعر التقديري الإجمالي",
    subtotal: "المجموع الفرعي", comboDiscount: "خصم الدمج",
    estimatedDuration: "مدة الإصلاح التقديرية",
    yourDevice: "جهازك", selectedRepairs: "الإصلاحات المختارة",
    noRepairs: "يرجى اختيار إصلاح واحد على الأقل.",
    changeModel: "تغيير الطراز", addRepair: "إضافة إصلاح",
    remove: "إزالة", change: "تغيير",
    popularBrands: "الماركات الشائعة", allBrands: "جميع الماركات",
    apple: "آبل", android: "أندرويد",
  },
  common: {
    loading: "جارٍ التحميل…", empty: "لا توجد سجلات.", error: "حدث خطأ.",
    required: "مطلوب", yes: "نعم", no: "لا", optional: "اختياري",
    from: "ابتداءً من", from_price: "ابتداءً من",
    fixed_price: "سعر ثابت", price_on_request: "السعر عند الطلب",
    price_after_diagnosis: "السعر بعد التشخيص",
  },
  footer: {
    tagline: "شريكك المحترف لإصلاح الهواتف الذكية في ألمانيا.",
    quickLinks: "روابط سريعة", popularRepairs: "الإصلاحات الشائعة",
    legal: "قانوني", contact: "التواصل", hours: "ساعات العمل",
    payment: "طرق الدفع",
    copyright: "© 2026 هاندي مايستر. جميع الحقوق محفوظة.",
  },
  cookie: {
    title: "يستخدم هذا الموقع ملفات تعريف الارتباط",
    text: "نستخدم ملفات تعريف الارتباط الضرورية لتشغيل الموقع. تساعدنا الاختيارية في تحسين الخدمة. يمكنك تغيير اختيارك في أي وقت.",
    acceptAll: "قبول الكل", onlyEssential: "الضرورية فقط",
    settings: "الإعدادات", necessary: "ضروري",
    statistics: "إحصاءات", marketing: "تسويق",
    external: "وسائط خارجية", save: "حفظ الاختيار",
  },
  scarcity: {
    low_stock: "الكمية المتاحة قليلة",
    out_of_stock: "غير متوفر حالياً — يرجى الاستفسار",
    in_stock: "متوفر",
  },
};
